<template>
    <div class="card" :class="state.deactive ? 'deactive' : ''">
      <div class="card__checkbox" v-if="hasCheckbox">
        <AppCheckbox :checked="state.isActive"/>
      </div>
      <div class="card__header">
        <p class="subtitle">{{ state.title }}</p>
      </div>
      <div class="card__body">
        <div class="card__data"
             :class="dataItem.modifier"
             v-for="dataItem in state.data"
             :key="dataItem.name"
        >
          <span class="card__data-name">{{ dataItem.name }}:</span>
          <span class="card__data-value">{{ dataItem.value }}</span>
        </div>
      </div>
      <div class="card__footer">
        <div class="card__show-button link" @click.stop="showItem">
          Просмотр
        </div>

        <div class="card__menu" v-if="currentUser.is_superuser" @click.stop="toggleControls">
          <div class="card__menu-button">
            <svg class="ellipsis-icon" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="2" r="2" fill="currentColor"/>
              <circle cx="11" cy="2" r="2" fill="currentColor"/>
              <circle cx="21" cy="2" r="2" fill="currentColor"/>
            </svg>
          </div>
          <div class="card__menu-popup" v-if="state.isControlsActive">
            <AppPopupMenu :items="{ update: true, remove: true }"
                          @update-item="updateItem"
                          @remove-item="removeItem"
            />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppPopupMenu from '@/components/page/popup/AppPopupMenu'
export default {
  name: 'AppPageCard',
  components: { AppPopupMenu, AppCheckbox },
  props: {
    state: {
      type: Object,
      default: () => ({
        isActive: false,
        isControlsActive: false,
        data: []
      })
    },
    hasCheckbox: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    showItem () {
      this.$emit('show-item', this.state.id)
    },
    toggleControls () {
      this.$emit('toggle-controls', this.state.id)
    },
    updateItem () {
      this.$emit('update-item', this.state.id)
    },
    removeItem () {
      this.$emit('remove-item', this.state.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.card {
  position: relative;
  background: $color_sixth;
  padding: 16px 16px 0;

  &.deactive {
    opacity: .5;
  }

  &__header {
    margin-bottom: 20px;
  }

  &__checkbox {
    margin-bottom: 20px;
  }

  &__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;

    @media screen and (max-width: $mobile_start) {
      grid-template-columns: 1fr;
      grid-column-gap: 0;
    }
  }

  &__data  {
    font-size: 16px;
    color: $font_color_second;
    margin-bottom: 20px;
    margin-right: 20px;

    @media screen and (max-width: $mobile_start) {
      font-size: 14px;
      margin-right: 0;
      width: 100%;
    }

    &:last-child {
      margin-bottom: 0;
      margin-right: 0;
    }

    &-name {
      display: inline-block;
      font-weight: 600;
      margin-right: 8px;
    }

    &-value {
      display: inline-block;
    }
  }

  &__footer {
    padding-top: 20px;
    padding-bottom: 10px;
    font-size: 16px;

    @media screen and (max-width: $mobile_start) {
      font-size: 14px;
    }
  }

  &__show-button {

  }

  &__menu {
    position: absolute;
    z-index: 10;
    top: auto;
    left: auto;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      color: $font_color_second;
      transition: .3s;

      @media screen and (min-width: $hover_enable_width) {
        &:hover {
          color: $color_second-light;
        }
      }
    }

    &-popup {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 100%
    }
  }
}

// модификаторы под различные нужды компонентов (например выделить статус другим цветом)
.card__data {
  &.status {
    .card__data-value {
      &::before {
        content: '';
        display: inline-block;
        @include size(11px);
        border-radius: 50%;
        background: currentColor;
        margin-right: 8px;
      }
    }

    &.success {
      .card__data-value {
        color: $color_success;
      }
    }
    &.warning {
      .card__data-value {
        color: $color_warning;
      }
    }
    &.error {
      .card__data-value {
        color: $color_error;
      }
    }
    // цвета колонок задач
    &.blue {
      .card__data-value {
        color: #2278BA;
      }
    }
    &.orange {
      .card__data-value {
        color: #F86758;
      }
    }
    &.pink {
      .card__data-value {
        color: #F86758;
      }
    }
    &.green {
      .card__data-value {
        color: #F86758;
      }
    }
    &.purple {
      .card__data-value {
        color: #F86758;
      }
    }

    &.violet {
      .card__data-value {
        color: #143568;
      }
    }
    // /цвета колонок задач
  }
}
</style>
